<template>
  <div
    class="svg-icon"
    @mouseover="() => this.$emit('mouseover', { hover: true })"
    @mouseleave="() => this.$emit('mouseleave', { leave: true })"
    @click="() => this.$emit('click', { click: true })"
  />
</template>
<script>
import axios from 'axios';
import icons from '@/utils/icon-loader';
const cache = new Map();
export default {
  name: 'SvgIcon',
  status: 'prototype',
  props: {
    name: {
      type: String,
      required: true,
    },
    viewBox: {
      type: String,
      default: '0 0 18 18',
    },
    fill: {
      type: String,
      default: null,
    },
    height: {
      type: [String, Number],
      default: '18px',
    },
    width: {
      type: [String, Number],
      default: '18px',
    },
  },
  watch: {
    fill: function(val) {
      this.fetchIcon();
    },
    name(v) {
      this.fetchIcon();
    },
  },
  async mounted() {
    await this.fetchIcon();
  },
  updated() {
    this.$el.children[0].style.fill = this.fill;
  },
  methods: {
    async fetchIcon() {
      const currPath = './' + this.name + '.svg';
      const file = icons(currPath);
      if (!cache.has(currPath)) {
        try {
          cache.set(currPath, axios.get(file).then(r => r.data));
        } catch (e) {
          cache.delete(currPath);
        }
      }
      if (cache.has(currPath)) {
        this.$el.innerHTML = await cache.get(currPath);
        const parentFill = this.$el.getElementsByClassName('parent-fill')[0];
        const parentStroke = this.$el.getElementsByClassName('parent-stroke')[0];
        const childrens = this.$el.children[0].getElementsByClassName('children-fill');
        if (this.fill) {
          if (parentFill) {
            parentFill.setAttribute('fill', this.fill);
          }
          if (parentStroke) {
            parentStroke.setAttribute('stroke', this.fill);
          }
          Array.from(childrens).map(children => {
            children.style.fill = this.fill;
          });
        }
        this.$el.children[0].setAttribute('viewBox', this.viewBox);
        if (this.fill) {
          Array.from(this.$el.children[0].children).map(item => {
            item.removeAttribute('fill');
          });
        }
        if (this.width !== 'auto') {
          this.$el.children[0].style.width = this.width;
          this.$el.children[0].setAttribute('width', this.width);
        }
        if (this.height !== 'auto') {
          this.$el.children[0].style.height = this.height;
          this.$el.children[0].setAttribute('height', this.height);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.svg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
